import { useState } from 'react';
import { CanvasTable } from './ScheduleChart';
import { ScheduleTable } from './ScheduleTable';
import { useTranslation } from 'react-i18next';

interface TargetPowerScheduleProps {
  targetPowerSchedule: Map<number, number>;
  targetPowerElectric: number | null | undefined;
  panelArea: { w: number; h: number };
}

export const TargetPowerSchedule = ({
  targetPowerSchedule,
  targetPowerElectric,
  panelArea,
}: TargetPowerScheduleProps) => {
  const [t] = useTranslation();
  const [dailyTargetPowerElectricMap, setDailyTargetPowerElectricMap] = useState(targetPowerSchedule);
  const [showTargetPowerElectric, setShowTargetPowerElectric] = useState(true);
  const [showAverageTargetPowerElectric, setShowAverageTargetPowerElectric] = useState(true);
  const padding = { left: 95, top: 10, right: 10 };

  return (
    <>
      <div className="pb-4 text-sm w-[880px] text-justify pl-6 pr-4">
        <h3>{t('Zeitplan für flexible Gasproduktion erstellen')}</h3>

        <p>
          {t(
            'Hier können Sie statt einer konstanten 24/7‑Leistung ein variables Gasproduktionsprofil festlegen. Das sichert die gewünschte durchschnittliche Zielbemessungsleistung und passt die Erzeugung auf sich im Verlauf der Woche variierende Strompreise an. Als Vorschlag sehen sie die von der Optimierung ermittelte Gasprognose, die sie übernehmen oder verändern können. Änderungen können direkt im Diagramm oder über Eingaben in der Tabelle vorgenommen werden. ',
          )}
        </p>
        <div className="flex items-end justify-end">
          <label className="flex items-center text-sm font-semibold mr-4 ">
            <input
              type="checkbox"
              checked={showTargetPowerElectric}
              onChange={() => {
                setShowTargetPowerElectric(!showTargetPowerElectric);
              }}
              className="w-4 h-4 mr-2 accent-green-200"
            />
            {t('Fixe Zielbemessungsleistung')}
          </label>
          <label className="flex items-center text-sm font-semibold ">
            <input
              type="checkbox"
              checked={showAverageTargetPowerElectric}
              onChange={() => {
                setShowAverageTargetPowerElectric(!showAverageTargetPowerElectric);
              }}
              className="w-4 h-4 mr-2 accent-green-200"
            />
            {t('Durchschnittliche Zielbemessungsleistung')}
          </label>
        </div>
      </div>
      {targetPowerElectric && (
        <div className="px-4">
          <CanvasTable
            maxValue={targetPowerElectric * 1000 * 2}
            targetPowerElectric={targetPowerElectric * 1000}
            dailyTargetPowerElectric={Array.from(dailyTargetPowerElectricMap.values())}
            panelArea={panelArea}
            padding={padding}
            showTargetPowerElectric={showTargetPowerElectric}
            showAverageTargetPowerElectric={showAverageTargetPowerElectric}
          />
          <ScheduleTable
            targetPowerElectric={targetPowerElectric * 1000}
            dailyTargetPowerElectricMap={dailyTargetPowerElectricMap}
            setDailyTargetPowerElectricMap={setDailyTargetPowerElectricMap}
            panelArea={panelArea}
            padding={padding}
          />
        </div>
      )}
    </>
  );
};
